(() => {
  const initFunnyReviews = (section) => {
    if (!section || section.dataset.funnyReviewsReady === 'true') return;
    section.dataset.funnyReviewsReady = 'true';

    const modal = section.querySelector('[data-review-modal]');
    const modalImage = section.querySelector('[data-review-modal-image]');
    const photoButtons = section.querySelectorAll('[data-review-photo]');
    const closeButtons = section.querySelectorAll('[data-review-modal-close]');

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      if (modalImage) {
        modalImage.removeAttribute('src');
        modalImage.alt = '';
      }
      document.body.classList.remove('funny-reviews-modal-open');
    };

    photoButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!modal || !modalImage) return;
        const image = button.querySelector('img');
        if (!image) return;

        modalImage.src = image.currentSrc || image.src;
        modalImage.alt = image.alt || 'Customer review photo';
        modal.hidden = false;
        document.body.classList.add('funny-reviews-modal-open');
      });
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-funny-reviews]').forEach(initFunnyReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
